import React from 'react';
import { connect } from 'react-redux';
import { EventRole } from 'src/imports/server-main/authorization.enum';
import Badge from 'antd/lib/badge';
import 'antd/lib/badge/style/index.css';
var selfStyle = require('./styles.scss');
var MenuWorkspaceEventRoleBadge = function (props) { return (props.workspaceEvent.userEventRoles && props.workspaceEvent.userEventRoles.length > 0
    ? React.createElement("span", { className: selfStyle.badge },
        React.createElement(Badge, { count: props.workspaceEvent.userEventRoles.length }))
    : null); };
var mapStateToProps = function (state) { return ({
    workspaceEvent: {
        userEventRoles: state.workspaceEvent.userEventRoles && state.workspaceEvent.userEventRoles.data.filter(function (uER) { return uER.role === EventRole.Pending; }),
    },
}); };
export default connect(mapStateToProps)(MenuWorkspaceEventRoleBadge);



//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageMenu/MenuWorkspaceEventRoleBadge.tsx
// module id = 816
// module chunks = 0